import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Login";
import Dashboard from "./Dashboard";
import ChangePassword from "./ChangePassword";
import BulletLibrary from "./BulletLibrary";
import UserManagement from "./UserManagement";
import { createTheme } from "@mui/material/styles";
import { responsiveFontSizes } from '@mui/material/styles';


/**
 * Custom MUI theme reflecting HorusVision-like styling:
 * - Dark background
 * - Orange primary color
 * - Minor overrides for the DataGrid
 */
let horusTheme = createTheme({
    palette: {
      mode: "dark",
      primary: { main: "#ff6600" },
      background: { default: "#13171a", paper: "#1c2023" },
    },
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: "1px solid #444",
            backgroundColor: "#1c2023",
          },
          columnHeaders: {
            backgroundColor: "#24292e",
          },
        },
      },
    },
});
horusTheme = responsiveFontSizes(horusTheme);

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route 
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route 
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <BulletLibrary theme={horusTheme} />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<h1>Not Found</h1>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
